"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalysisRunFailedEvent = exports.AnalysisRunCompletedEvent = exports.AnalysisRunStartedEvent = void 0;
const zod_1 = require("zod");
const event_1 = require("../event");
exports.AnalysisRunStartedEvent = (0, event_1.createEventClass)('AnalysisRunStartedEvent', zod_1.z.object({
    buildId: zod_1.z.string(),
    projectId: zod_1.z.string().optional(),
    organizationId: zod_1.z.string().optional(),
    analysisType: zod_1.z.string(),
    workflowId: zod_1.z.string().optional(),
}));
exports.AnalysisRunCompletedEvent = (0, event_1.createEventClass)('AnalysisRunCompletedEvent', zod_1.z.object({
    buildId: zod_1.z.string(),
    projectId: zod_1.z.string().optional(),
    organizationId: zod_1.z.string().optional(),
    analysisType: zod_1.z.string(),
    workflowId: zod_1.z.string().optional(),
    resultCount: zod_1.z.number().int().nonnegative().optional(),
    startedAt: zod_1.z.string(),
    completedAt: zod_1.z.string(),
}));
exports.AnalysisRunFailedEvent = (0, event_1.createEventClass)('AnalysisRunFailedEvent', zod_1.z.object({
    buildId: zod_1.z.string(),
    projectId: zod_1.z.string().optional(),
    organizationId: zod_1.z.string().optional(),
    analysisType: zod_1.z.string(),
    workflowId: zod_1.z.string().optional(),
    errorMessage: zod_1.z.string().optional(),
    startedAt: zod_1.z.string(),
    completedAt: zod_1.z.string(),
}));
//# sourceMappingURL=analysis-events.js.map